import AppGrid from './AppGrid';

function AppCol(props) {
  return <AppGrid {...props} name='col' />
}

export default AppCol;
